import React, {useState, useEffect } from 'react'
import {connect} from 'react-redux'
import { Carousel, CarouselItem, CarouselControl, CarouselIndicators, CarouselCaption, Container ,Row,Col} from 'reactstrap';

import {setCurrenttab_Games} from '../../Actions/Actionexport'
import Firstimg from '../../Resources/Images/graphicicon1.jpg'
import Gamedisplay from '../Gamedisplay';
import secondimg from '../../Resources/Images/graphicicon.jpg'


const items = [
    {
      src: Firstimg,
      altText: 'slide1',
      caption: ''
    },
    {
      src: secondimg,
      altText: 'Slide 2',
      caption: ''
    },
    
  ];


const Games=(props)=>{
    useEffect(()=>{
        props.setcurrenttab_games()
    },[props])
    
    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);
  
    const next = () => {
      if (animating) return;
      const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
      setActiveIndex(nextIndex);
    }
  
    const previous = () => {
      if (animating) return;
      const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
      setActiveIndex(nextIndex);
    }
  
    const goToIndex = (newIndex) => {
      if (animating) return;
      setActiveIndex(newIndex);
    }
  
    const slides = items.map((item) => {
      return (
        <CarouselItem
          onExiting={() => setAnimating(true)}
          onExited={() => setAnimating(false)}
          key={item.src}
        >
          <img src={item.src} alt={item.altText}  className="img-fluid"/>
          <CarouselCaption captionText={item.caption} captionHeader={item.caption} />
        </CarouselItem>
      );
    });

    return(
     <Container  className="mt-5">
       <Row >
         <Col>
         <Carousel
      activeIndex={activeIndex}
      next={next}
      previous={previous}
      style={{overflow:'hidden'}}
     
    >
      <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
      {slides}
      <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
      <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
    </Carousel>
         </Col>
       </Row>
       <Row>
         <Col lg={{offset:3}}>
        
         <Gamedisplay animationName="coolerfrog_web" titlename="Buggy frog" download="download now"
                        content=" Buggy frog is casual kids game available in google play store .Join your hungry buggy frog and eat the bugs to save your garden.
                  This game has got a single level where you have to save your flowers from the bug
                  just by touching the bugs and eating it."></Gamedisplay >
    <hr></hr>
         </Col>
       </Row>
     </Container>
           
      
    
 
    )
}
const mapdispatchtomethod=(dispatch)=>{
    return{
        setcurrenttab_games:()=>dispatch(setCurrenttab_Games())
    }
}
export default connect(null,mapdispatchtomethod)(Games) 